module.exports = __webpack_public_path__ + "img/widget_015.34366bbf.png";